module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 22.d026a65d.png";